import { useMemo } from "react"

import { Booking } from "modules/ClientAccount/utils"
import { Text } from "ui-kit/components-branded/index"
import { HelpTooltip } from "components"
import { formatPrice } from "utils/utils"
import { useShowPrice } from "utils/hooks/useShowPrice"

export function PaymentInfo({
    price,
    moneyBack,
    paid,
    currency,
    canceled,
    forFree,
}: {
    price: number
    forFree: boolean
    moneyBack: boolean
    paid: boolean
    canceled: boolean
    currency: Booking["currency"]
}) {
    const showPrice = useShowPrice()
    const text = useMemo(() => {
        if (moneyBack) {
            return "Возврат"
        }
        if (canceled && !moneyBack && !paid) {
            return "Не оплачено"
        }
        if (paid) {
            return "Оплачено"
        }
    }, [])
    if (!text) return null
    return (
        <span className="is-inline-flex mgt-4">
            {showPrice && (
                <Text isAccent={moneyBack}>
                    {text} {!forFree && formatPrice(price, currency)}
                </Text>
            )}
            &nbsp;
            {moneyBack && showPrice && (
                <HelpTooltip
                    placement="bottom"
                    overlay={
                        <Text isSecondary className="has-text-dark-60">
                            Мы&nbsp;отправили деньги на&nbsp;ваш счет. Обычно они доходят
                            в&nbsp;течение трех банковских дней.
                        </Text>
                    }
                />
            )}
        </span>
    )
}
